import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { useLocation } from "react-router-dom";
import styled from 'styled-components';

export const LoginButton = () => {
  const { loginWithRedirect, logout } = useAuth0();
  const location = useLocation();

// this component handles the login authorization of a signed up user in our Auth0 tenant
  const handleLogin = async () => {
    // If user is on /home page, log them out and redirect to index
    if (location.pathname === '/home') {
      logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
      return;
    }
    
    // Otherwise, proceed with normal login
    await loginWithRedirect({
      appState: {
        returnTo: "/home",
      },
    });
  };

  return (
    <Button className="p-3" onClick={handleLogin}>
        LOG IN
    </Button>
  );
};

export const Button = styled.button`
    color: white;
    background-color: #FF7234;
    font-size: 1.2em;
    border-radius: 30px;
    border: none;
    width: 350px;
    font-weight: 700;
`;